// Angular
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';

// Material
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

// Local library
import { TranslatePipe } from '@amwager/data-access';

/**
 * Payload used to populate the wager confirmation dialog
 */
export interface WagerConfirmDialogData {
  betType:
    | 'bet-now'
    | 'save-bet'
    | 'submit-saved-bet'
    | 'remove-saved-bet'
    | 'cancel-bet'
    | string;
  title: string;
  /** When set, the body shows this plain text instead of ticket details (bulk actions) */
  message?: string;
  eventName: string;
  raceId: string | number;
  baseAmount: number;
  poolId: string;
  /** Raw modifier off the ticket; `modifierAbbr` is what the body renders */
  modifier: string;
  /** Two-letter modifier badge (BX/KB/PB/KW), blank when it has none */
  modifierAbbr?: string;
  runners: string;
  totalAmount?: number;
  confirmButtonLabel?: string;
}

/**
 * Wager confirmation dialog (Place/Save Wager, My Bets flows)
 */
@Component({
  selector: 'feature-mat-wager-confirm-dialog',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, TranslatePipe],
  templateUrl: './wager-confirm-dialog.component.html',
  styleUrls: ['./wager-confirm-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WagerConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<WagerConfirmDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public data: WagerConfirmDialogData
  ) {}

  /**
   * Confirm the wager (closes with true)
   * @returns {void}
   */
  submit(): void {
    this.dialogRef.close(true);
  }

  /**
   * Cancel the wager (closes with false)
   * @returns {void}
   */
  close(): void {
    this.dialogRef.close(false);
  }
}
